module.exports = __webpack_public_path__ + "img/NL285.aca26803.png";